import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LANGUAGES } from './constants.js';
import { ChevronDownIcon } from '@contra/icons/icons';
import { Button, Divider, Group, Menu, TextInput } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';
export const LanguageSelect = ({ onSelect, selectedLanguage, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState('');
    const inputRef = useRef(null);
    const items = Object.keys(LANGUAGES)
        .map((language) => {
        return {
            label: LANGUAGES[language],
            value: language,
        };
    })
        .filter((item) => item.label.toLowerCase().startsWith(search.toLowerCase()));
    useEffect(() => {
        if (isOpen) {
            setSearch('');
            setTimeout(() => {
                inputRef.current?.focus();
            }, 100);
        }
    }, [isOpen]);
    return (_jsxs(Menu, { closeOnEscape: true, keepMounted: true, onClose: () => setIsOpen(false), opened: isOpen, position: "bottom-start", shadow: "md", width: 200, withinPortal: false, zIndex: 1_001, children: [_jsx(Menu.Target, { children: _jsx(Button, { color: "#14171F", fw: 492, left: 10, onClick: () => setIsOpen((previous) => !previous), pos: "absolute", size: "compact-sm", top: 10, variant: "transparent", w: "fit-content", children: _jsxs(Group, { align: "center", gap: 4, wrap: "nowrap", children: [selectedLanguage, _jsx(ChevronDownIcon, { size: 12 })] }) }) }), _jsxs(Menu.Dropdown, { className: "contra-bn-code-block-language-select", children: [_jsx(TextInput, { onChange: (event) => setSearch(event.currentTarget.value), onKeyDown: (event) => {
                            if (event.key === 'Enter' && items.length) {
                                event.preventDefault();
                                event.stopPropagation();
                                onSelect(items[0].value);
                                setIsOpen(false);
                            }
                        }, placeholder: "Search languages...", ref: inputRef, styles: {
                            input: {
                                border: 'none',
                            },
                        }, tabIndex: 1, value: search }), _jsx(Divider, { py: 4 }), _jsx("div", { className: "contra-bn-code-block-language-select-items", children: items.map(({ label, value }) => {
                            return (_jsx(Menu.Item, { className: "contra-bn-code-block-language-select-item", onClick: () => {
                                    onSelect(value);
                                    setIsOpen(false);
                                }, children: label }, value));
                        }) }), !items.length && (_jsx("div", { className: "contra-bn-code-block-language-select-no-results", children: "No results found" }))] })] }));
};
//# sourceMappingURL=LanguageSelect.js.map